import * as React from 'react';
/**
 *
 * Original name: PDF
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22352%3A2788
 *
 */
export const PdfPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M23.955 36.89h.465c2.955 0 4.695-.945 4.695-4.035 0-2.865-1.5-3.855-4.44-3.855H21v11.475h2.955V36.89Zm.66-2.355h-.66V31.28h.69c1.02 0 1.53.345 1.53 1.62 0 1.2-.6 1.635-1.56 1.635ZM32 29v11.475h3.255c3.42 0 4.995-2.07 4.995-5.61C40.25 30.8 38.675 29 35.27 29H32Zm3.165 9.255h-.225V31.19h.225c1.14 0 1.95.81 1.95 3.645 0 2.61-.795 3.42-1.95 3.42Zm10.775 2.22V36.23h4.2v-2.28h-4.2v-2.67h4.32V29H43v11.475h2.94Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m42.586 9.757 5.656 5.658A5.96 5.96 0 0 1 50 19.657V25h-4v-4h-9v-9H18v40h28v-7h4v11H14V8h24.343a5.96 5.96 0 0 1 4.243 1.757Z", fill: "currentColor" })));
